import React, { useCallback, useMemo } from 'react';
import { SelectField } from '../../../../../../../ui-toolkit';
import { manualCheckDisbursementCategoryOptions } from '../../../../../../../types/accounting/eManualCheckDisbursementCategory';
import { useField } from 'formik';
import { useHasPermissions } from '../../../../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from '../../../../../../../types/administration/userAdministration/ePermissions';
import { format } from 'date-fns';
import { isIssuanceDateCategory } from '../isIssuanceDateCategory';

export const CheckCategorySelect: React.FC<{
  isReadOnly: boolean;
  isCheckPrinted: boolean;
}> = ({ isReadOnly, isCheckPrinted }) => {
  const hasIssuanceDateEditPermissions = useHasPermissions([ePermissions.EscrowCheckIssuanceDateEdit]);
  const [{ value: issuanceDate }, , { setValue: setIssuanceDate }] = useField<string | undefined>('value.issuanceDate');

  const partialShouldSetIssuanceDate = useMemo(() => {
    return !issuanceDate && !isReadOnly && !isCheckPrinted && hasIssuanceDateEditPermissions;
  }, [issuanceDate, isReadOnly, isCheckPrinted, hasIssuanceDateEditPermissions]);

  const today = useMemo(() => format(new Date(), 'yyyy-MM-dd'), []);

  const onChange = useCallback(
    async (newCheckCategory: string | undefined) => {
      if (partialShouldSetIssuanceDate && isIssuanceDateCategory(newCheckCategory)) {
        await setIssuanceDate(today);
      }
    },
    [setIssuanceDate, partialShouldSetIssuanceDate, today]
  );

  return (
    <SelectField
      className={'basis-1/3 pr-2'}
      name={`value.category`}
      options={manualCheckDisbursementCategoryOptions}
      label={'Category'}
      isDisabled={isReadOnly}
      onChange={onChange}
    />
  );
};
